import Grid from 'apollo-react/components/Grid';
import TrialCard from './reviews_card';
import FiltersPanel from './FiltersPanel';
import { useRequestFilters } from '../../../hooks/features/requests/useRequestFilters';
import './styles.css';

const ReviewsListCards = ({
  requests,
  activeTab,
  onNavigate,
  tagOptions,
  status,
}) => {
  const {
    filters,
    selectedTags,
    handleFilterChange,
    handleTagChange,
    filteredRequests,
  } = useRequestFilters(requests, status);

  return (
    <Grid container spacing={2} sx={{ width: '100%' }}>
      {/* Filter Section */}
      <Grid size={{ xs: 12, md: 3 }}>
        <FiltersPanel
          filters={filters}
          onFilterChange={handleFilterChange}
          tagOptions={tagOptions}
          selectedTags={selectedTags}
          onTagChange={handleTagChange}
        />
      </Grid>

      {/* Clinical Trials List */}
      <Grid size={{ xs: 12, md: 9 }}>
        {filteredRequests?.map((request, index) => (
          <TrialCard
            key={request.id}
            request={request}
            activeTab={activeTab}
            onNavigate={onNavigate}
            status={status}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default ReviewsListCards;
